import S3StoragePlugin from './S3StoragePlugin';

export * from './S3Storage';
export default S3StoragePlugin;
